export default __webpack_public_path__ + "static/media/DigitalFranchise.079731a5dfeabcb50abb703544de5ede.webp";